import Album from '../components/Album';
import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';
import editorials from '../mocks/editorials.json';

const Editorials = () => {
    return (
        <>
            <Breadcrumb history={[{ title: 'Home', to: '/' }]} current='Editoriali' />
            <section id='editorials' className='services album'>
                <TitlePage title='Editoriali' />
                <div className='container'>
                    <div className='row gy-4'>
                        {editorials.map(item => (
                            <Album title={item.title} to={`gallery/${item.id}`} path={item.path} alt={item.alt} externalUrl={item.externalUrl}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};
export default Editorials;
